import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DatePicker, Form, Input, Select, Checkbox } from 'antd';

import CRUDE_City from '../../../objects/City/crude'
import REDUX_City from '../../../objects/City/reducer'
import REDUX_TipiMeropriyatii from '../../../objects/TipiMeropriyatii/reducer'
import REDUX_UrovenMeropriyatiya from '../../../objects/UrovenMeropriyatiya/reducer'
import { errorCatch, GET, GETWITH, QueryDetail, QueryParam, useFormObserverContext } from 'fennec-ui';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import locale from 'antd/es/date-picker/locale/ru_RU';
import EmojiTextArea from '../../../common/EmojiTextArea';
dayjs.locale('ru');

const { Option } = Select;

export default function IzmenitMeropriyatiyaGonorar(props) {
    const { auth, object, form, sourceKey } = props;
    const dispatch = useDispatch();

    const city = useSelector(REDUX_City.selector.array);
    const tipMeropriyatiya = useSelector(REDUX_TipiMeropriyatii.selector.array);
    const urovenMeropriyatiya = useSelector(REDUX_UrovenMeropriyatiya.selector.array);
    const [shabloniSudeiskikhGonorarov, setShabloniSudeiskikhGonorarov] = useState([]);

    let orgKey = undefined;
    let orgFlt = undefined;
    if (object?.organizatorFederatsiyaID) {
        orgKey = "fed";
        orgFlt = QueryParam("w-organizatorFederatsiya.ID", object?.organizatorFederatsiyaID)
    } else if (object?.organizatorRegionalnoeOtdelenieID) {
        orgKey = "reg";
        orgFlt = QueryParam("w-organizatorRegionalnoeOtdelenie.ID", object?.organizatorRegionalnoeOtdelenieID)
    } else if (object?.organizatorMeropriyatiyaID) {
        orgKey = "org";
        orgFlt = QueryParam("w-organizatorMeropriyatiya.ID", object?.organizatorMeropriyatiyaID)
    } else if (object?.organizatorShkolaID) {
        orgKey = "school";
        orgFlt = QueryParam("w-organizatorShkola.ID", object?.organizatorShkolaID)
    }
    let eventFlt = undefined;
    if (object) {
        eventFlt = QueryParam("w-eqornu-meropriyatie.ID", object?.ID)
    }


    useEffect(() => {
        form.resetFields();
        CRUDE_City.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_City.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');
        // console.log(object)
        GET(auth, '/api/tipimeropriyatii/' + orgKey,
            ({ data }) => {
                dispatch(REDUX_TipiMeropriyatii.actions.setArray(data));
            },
            (err) => errorCatch(err));
        GET(auth, '/api/urovenmeropriyatiya/' + orgKey,
            ({ data }) => {
                dispatch(REDUX_UrovenMeropriyatiya.actions.setArray(data));
            },
            (err) => errorCatch(err));
        GETWITH(auth, '/api/shablonisudeiskikhgonorarov/list/' + orgKey, [
            ...((orgFlt) ? [orgFlt] : []),
            ...((eventFlt) ? [eventFlt] : []),
            QueryDetail("model")
        ],
            ({ data }) => {
                setShabloniSudeiskikhGonorarov(data);
            },
            (err) => errorCatch(err));
    }, []);
    const cityOptions = city.map((i) => <Option key={i.ID} value={i.ID}>{i.name}</Option>);
    const tipMeropriyatiyaOptions = tipMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    const urovenMeropriyatiyaOptions = urovenMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    // const shabloniSudeiskikhGonorarovOptions = shabloniSudeiskikhGonorarov.map((i) => <Option key={i.ID} value={i.ID} label={i.nazvanie}>{i.nazvanie}</Option>);
    const shabloniSudeiskikhGonorarovOptions = shabloniSudeiskikhGonorarov.map((i) => {
        let desc = "";
        if (i?.organizatorFederatsiya) {
            desc = "Федерация"
        } else if (i?.organizatorRegionalnoeOtdelenie) {
            desc = "" + i?.organizatorRegionalnoeOtdelenie?.nazvanie
        } else if (i?.organizatorShkola) {
            desc = "" + i?.organizatorShkola?.nazvanieShkoliTantsev
        } else if (i?.organizatorMeropriyatiya) {
            desc = "" + i?.organizatorMeropriyatiya?.nazvanie
        }

        if (i?.meropriyatie) {
            desc += ", " + `${i?.meropriyatie?.nazvanieMeropriyatiya} - ${dayjs(i?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(i?.meropriyatie?.mestoProvedeniya) ? "(" + i?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}`
        }
        return (<Option key={i.ID} value={i.ID} label={i.nazvanie}>
            <div><span>{i.nazvanie}</span></div>
            {desc && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>{desc}</div>}
        </Option>)
    });

    const [isChangedForm, isChangedField, onValuesChange] = useFormObserverContext()

    return (
        <>
            <Form
                form={form}
                onValuesChange={onValuesChange}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                }}
            >
                <div style={{ display: "flex", gap: "5px" }}>
                    <div style={{ flexBasis: "100%" }}>
                        <Form.Item label="Шаблон гонораров судьям"
                            name="shablonSudeiskikhGonorarovID"
                            rules={[{ required: false, message: 'Пожалуйста, укажите шаблон!' }]}
                        >
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                optionLabelProp="label"
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                                }
                            >
                                {shabloniSudeiskikhGonorarovOptions}
                            </Select>
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </>
    );
}
